import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Collapse } from "reactstrap"
import { Link } from "react-router-dom"
import "../../assets/css/Layout/Header.css"
import Configs from "../../config"
import {
  FaArrowTrendUp,  
} from "react-icons/fa6"
import { 
  FaHome,
  FaUsers, 
  FaRupeeSign, 
  FaBullhorn,
  FaTree,
  FaRoute,
} from "react-icons/fa"
import { 
  MdSettings, 
} from "react-icons/md" 

const Navbar = props => {
  const [dashboard, setdashboard] = useState(false)
  const [setting, setSetting] = useState(false)
  const [expense, setExpense] = useState(false)

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    removeActivation(items)
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="topnav ps-1 pe-0" style={{ zIndex: "1001" }}>
        <div className="container-fluid px-0">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav d-flex justify-content-between w-100">
                <div className="d-flex gap-2">
                  {/* dashboard */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}dashboard`}
                    >
                      <FaHome size={20} className="me-2 mb-1" />
                      {"Dashboard"} {props.menuOpen}
                    </Link>
                  </li>
                  {/* Staff */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}staff`}
                    >
                      <FaUsers size={20} className="me-2 mb-1" />
                      {"Staff"} {props.menuOpen}
                    </Link>
                  </li>

                  {/* Lead */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}leads`}
                    >
                      <FaArrowTrendUp size={20} className="me-2 mb-1" />
                      {"Lead"} {props.menuOpen}
                    </Link>
                  </li>

                  {/* Marketing */}
                  <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none">
                      <FaBullhorn size={20} className="me-2 mb-1" />
                      {"Marketing"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        to={`${Configs.appurl}opprtunity`}
                        className="text-dark dropdown-item"
                      >
                        Opprtunity
                      </Link>
                      <Link
                        to={`${Configs.appurl}cold-calling`}
                        className="text-dark dropdown-item"
                      >
                        Cold Calling
                      </Link>
                    </div>
                  </li>

                  {/* Payroll */}
                  <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none">
                      <FaRupeeSign size={20} className="me-2 mb-1" />
                      {"Payroll"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        to={`${Configs.appurl}emp-expenses`}
                        className="text-dark dropdown-item"
                      >
                        Employee Expenses
                      </Link>
                      <Link
                        to={`${Configs.appurl}emp-advance`}
                        className="text-dark dropdown-item"
                      >
                        Employee Advance
                      </Link>
                      <Link
                        to={`${Configs.appurl}punches`}
                        className="text-dark dropdown-item"
                      >
                        Punch Details
                      </Link>
                      <Link
                        to={`${Configs.appurl}salary-sheet`}
                        className="text-dark dropdown-item"
                      >
                        Salary Process
                      </Link>

                      <Link
                        to={`${Configs.appurl}salary-slip`}
                        className="text-dark dropdown-item"
                      >
                        Salary Slip
                      </Link>
                    </div>
                  </li>

                  {/* Location */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}location-track`}
                    >
                      <FaRoute size={20} className="me-2 mb-1" />
                      {"Location Tracking"} {props.menuOpen}
                    </Link>
                  </li>

                  {/* Leaves */}
                  <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none">
                      <FaTree size={20} className="me-2 mb-1" />
                      {"Leave Management"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        to={`${Configs.appurl}leaves`}
                        className="text-dark dropdown-item"
                      >
                        Leave
                      </Link>

                      <Link
                        to={`${Configs.appurl}holiday`}
                        className="text-dark dropdown-item"
                      >
                        Holiday
                      </Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none">
                      <MdSettings size={20} className="me-2 mb-1" />
                      {"Settings"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        to={`${Configs.appurl}roles`}
                        className="text-dark dropdown-item"
                      >
                        Roles
                      </Link>
                      <Link
                        to={`${Configs.appurl}allowances`}
                        className="text-dark dropdown-item"
                      >
                        Allowances
                      </Link>
                    </div>
                  </li>

                  {/* <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}services`}
                    >
                      <MdCleaningServices size={18} className="me-2 mb-1" />
                      {"Services"} {props.menuOpen}
                    </Link>
                  </li> */}

                  {/*<li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}locations`}
                    >
                      <FaMapMarkerAlt size={18} className="me-2 mb-1" />{" "}
                      Locations
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}payroll-report`}
                    >
                      <FaPoundSign size={18} className="me-2 mb-1" /> Payroll
                      
                    </Link>
                  </li>

                   <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}user-query`}
                    >
                      <MdQuestionAnswer size={18} className="me-2 mb-1" /> Query
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none">
                      <MdSettings size={18} className="me-2 mb-1" />
                      {"Settings"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        to={`${Configs.appurl}services`}
                        className="text-dark dropdown-item"
                      >
                        <MdCleaningServices size={18} className="me-2 mb-1" />{" "}
                        Services
                      </Link>

                      <Link
                        to={`${Configs.appurl}roles`}
                        className="text-dark dropdown-item"
                      >
                        <MdOutlineSecurity size={18} className="me-2 mb-1" />{" "}
                        Roles
                      </Link>
                    </div>
                  </li> */}
                </div>
              </ul>
              {/* <Dropdown>
                <DropdownToggle nav caret className="text-white">
                  <MdSettings className="me-2" />
                  Settings
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem>
                    <Link
                      to={`${Configs.appurl}locations`}
                      className="text-dark"
                    >
                      <FaLocationPin className="me-2" /> Locations
                    </Link>
                  </DropdownItem>
                  <DropdownItem>
                    <Link to={`${Configs.appurl}roles`} className="text-dark">
                      <FaUser className="me-2" /> Roles
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown> */}
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

export default Navbar
